module.exports = __webpack_public_path__ + "images/howtouse/flow04_76b09efdaf9c0454ae6ef173792ddcb9.png";